import React, { Component } from 'react'
import { Link } from 'react-router'
import './HomeFooter.scss'
import Logo from '../../../components/Logo'
class HomeFooter extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        const social = this.props.social.map((item, index) => {
          return (<li><Link to={`#${item.url}`}>{item.label}</Link></li>)
        })
        const links = this.props.links.map((item, index) => {
          return (<li><Link to={`#${item.url}`}>{item.label}</Link></li>)
        })
        return (
            <div className='home-footer text-center'>
              <Logo></Logo>
              <br/>
              <ul className='list-unstyled list-inline'>
                {social}
              </ul>
              <ul className='list-unstyled list-inline'>
                {links}
              </ul>
              <small>{this.props.strapline}</small>
            </div>
        )
    }
}

export default HomeFooter



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeFooter/index.js